// Environment para desarrollo (local/dev)
export const environment = {
  production: false,
  apiUrl: 'https://dev.api.partners.sdi.es/api/v1',
  useMockApi: false, // Activar mock API en desarrollo
  version: '1.1.4',
};
